import { Form, Input } from "antd";
import { useState } from "react";

import './InputLabeledComponent.scss';
import { useTranslation } from "react-i18next";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { set } from "lodash";

interface LabeledInputProps {
  inputName: string;
  placeHolder: string;
  type: string;
}

const InputLabeledComponent = (props: LabeledInputProps): JSX.Element => {
  const { t } = useTranslation();

  const [status, setStatus] = useState<string>('');

  const onFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    if (e.target.value.length > 0) {
      setStatus('top');
    } else {
      setStatus('focus');
    }
  };

  const onBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    if (e.target.value.length > 0) {
      setStatus('top');
    } else {
      setStatus('');
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.value.length > 0) {
      setStatus('top');
    } else {
      setStatus('focus');
    }
  };
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const onClickEyeIcon = (): void => {
    setShowPassword(!showPassword);
    console.log("change")
  }

  return (
    <div className="input-labeled-component">
      <label className={status}>
        <span className={status}>{props.placeHolder}</span>
        <Form.Item
          className="form-item"
          name={props.inputName}
          rules={[{ required: true, message: t("forms.validations.required-field")! }]}
        >
          <div className="input-wrapper">
            <Input
              type={
                props.type === "password"
                  ? (showPassword ? "text" : "password")
                  : props.type
              }
              onChange={onChange}
              onBlur={onBlur}
              onFocus={onFocus}
              autoComplete="off"
              className="app-input"
            />

            {props.type === "password" && (
              showPassword ? (
                <EyeInvisibleOutlined
                  className="eye-icon"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={onClickEyeIcon}
                />
              ) : (
                <EyeOutlined
                  className="eye-icon"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={onClickEyeIcon}
                />
              )
            )}

          </div>
        </Form.Item>

      </label>
    </div>

  );
};

export default InputLabeledComponent;
